module.exports = __webpack_public_path__ + "static/media/cardLast4Numb.1b46ce57.svg";